export const classifications = {
  types: {
    technical: { color: '#42a5f5', icon: 'cog' },
    political: { color: '#ef5350', icon: 'landmark' },
    social: { color: '#ab47bc', icon: 'users' },
    cultural: { color: '#8d6e63', icon: 'palette' },
    violent: { color: '#78909c', icon: 'bomb' },
    news: { color: '#ff9800', icon: 'newspaper' },
    opinion: { color: '#9c27b0', icon: 'quote' },
    creative: { color: '#ff4081', icon: 'paintbrush' },
    portrait: { color: '#6d4c41', icon: 'user' },
    landscape: { color: '#7cb342', icon: 'mountain' },
    abstract: { color: '#26a69a', icon: 'shapes' },
    document: { color: '#5c6bc0', icon: 'file-text' }
  },
  sentiment: {
    positive: { color: '#66bb6a', icon: 'smile' },
    negative: { color: '#ef5350', icon: 'frown' },
    neutral: { color: '#9e9e9e', icon: 'meh' },
    'very positive': { color: '#2e7d32', icon: 'laugh' },
    'very negative': { color: '#b71c1c', icon: 'angry' }
  },
  meta_categories: (() => {
    const groups = {
      'Politics & Government': [
        'Elections',
        'Public Policy',
        'Legislation',
        'International Relations',
        'Political Ideologies',
        'Governance',
        'Civil Rights',
        'Protests',
        'Government Corruption',
        'Political Analysis',
        'Political Parties'
      ],
      'Economy & Finance': [
        'Stock Market',
        'Personal Finance',
        'Macroeconomics',
        'Cryptocurrency',
        'Banking',
        'Investment',
        'Real Estate',
        'Job Market',
        'Inflation',
        'Trade & Tariffs',
        'Economic Policy',
        'Startups',
        'Venture Capital'
      ],
      Technology: [
        'Artificial Intelligence',
        'Blockchain',
        'Cybersecurity',
        'Software Development',
        'Big Data',
        'Cloud Computing',
        'Social Media Platforms',
        'Tech News',
        'Gadgets',
        'Augmented Reality',
        'Quantum Computing',
        'Web Development',
        'Mobile Apps'
      ],
      'Science & Environment': [
        'Climate Change',
        'Space Exploration',
        'Biotechnology',
        'Health Science',
        'Physics',
        'Environmental Policy',
        'Conservation',
        'Renewable Energy',
        'Wildlife',
        'Astronomy',
        'Geology',
        'Water Resources'
      ],
      'Health & Wellness': [
        'Mental Health',
        'Nutrition',
        'Fitness',
        'Public Health',
        'Diseases & Outbreaks',
        'Healthcare Systems',
        'Vaccines',
        'Medical Research',
        'Self-care',
        'Sleep',
        'Addiction',
        'Healthcare Policy'
      ],
      'Culture & Society': [
        'Religion',
        'Gender Issues',
        'LGBTQ+',
        'Ethics',
        'Philosophy',
        'Cultural Traditions',
        'Social Justice',
        'Inequality',
        'Education',
        'Family',
        'Language',
        'Urban Life',
        'Demographics'
      ],
      Entertainment: [
        'Movies',
        'TV Shows',
        'Music',
        'Celebrities',
        'Books',
        'Video Games',
        'Comics',
        'Streaming',
        'Theater',
        'Pop Culture',
        'Awards Shows',
        'Reviews'
      ],
      'Business & Industry': [
        'Marketing',
        'E-commerce',
        'Retail',
        'Manufacturing',
        'Transportation',
        'Supply Chain',
        'Business Strategy',
        'Management',
        'Human Resources',
        'Entrepreneurship',
        'Mergers & Acquisitions',
        'Advertising',
        'Consumer Reviews',
        'Product Reviews',
        'Consumer Complaints',
        'Customer Feedback',
        'Customer Service',
        'Sales',
        'Sales Strategies',
        'Brand Management',
        'Market Research',
        'Pricing Strategy'
      ],
      Sports: [
        'Football',
        'Basketball',
        'Baseball',
        'Soccer',
        'Tennis',
        'Olympics',
        'Esports',
        'Athlete Profiles',
        'Game Analysis',
        'Fantasy Sports',
        'Team News',
        'Sports Business'
      ],
      'Crime & Law': [
        'Criminal Justice',
        'Lawsuits',
        'Police',
        'Prisons',
        'Fraud',
        'Cybercrime',
        'Court Decisions',
        'Legal Reform',
        'Civil Cases',
        'Human Rights Law'
      ],
      Lifestyle: [
        'Travel',
        'Food & Drink',
        'Fashion',
        'Home Decor',
        'Parenting',
        'Hobbies',
        'Personal Development',
        'DIY',
        'Relationships',
        'Minimalism',
        'Frugality',
        'Time Management'
      ],
      'Pets & Animals': [
        'Pets',
        'Pet Care',
        'Pet Adoption',
        'Dog Breeds',
        'Cat Breeds',
        'Animal Welfare',
        'Animal Behavior',
        'Veterinary Medicine',
        'Wildlife Conservation',
        'Zoos & Aquariums'
      ],
      Education: [
        'Higher Education',
        'K-12 Education',
        'Online Learning',
        'Education Policy',
        'Student Life',
        'EdTech',
        'Standardized Testing',
        'Teaching Methods'
      ],
      'Technology & Society': [
        'Digital Privacy',
        'Misinformation',
        'Online Harassment',
        'Tech Ethics',
        'Internet Culture',
        'Surveillance',
        'Digital Identity',
        'Digital Divide'
      ],
      'Meta & Media': [
        'Journalism',
        'Media Criticism',
        'Content Creation',
        'Blogging',
        'Vlogging',
        'Podcasting',
        'News Analysis',
        'Press Freedom',
        'Fact-checking',
        'Media Bias'
      ],
      'Emotions & Tone': [
        'Humor',
        'Satire',
        'Inspirational',
        'Motivational',
        'Opinion',
        'Rant',
        'Critical',
        'Supportive',
        'Emotional',
        'Reflective'
      ],
      Events: [
        'Breaking News',
        'Natural Disasters',
        'Elections',
        'Anniversaries',
        'Cultural Festivals',
        'Product Launches',
        'Conferences',
        'Scandals',
        'Accidents',
        'Obituaries'
      ],
      'Geography & Regions': [
        'United States',
        'Europe',
        'Asia',
        'Africa',
        'Latin America',
        'Middle East',
        'Global',
        'Local News',
        'Urban Issues',
        'Rural Issues'
      ],
      Miscellaneous: [
        'Memes',
        'Trends',
        'Viral Content',
        'Trivia',
        'Opinion Polls',
        'Quotes',
        'User Tips',
        'Announcements',
        'FAQs',
        'Historical Context'
      ]
    };

    const colors = {
      'Politics & Government': '#f44336',
      'Economy & Finance': '#4caf50',
      Technology: '#2196f3',
      'Science & Environment': '#4dd0e1',
      'Health & Wellness': '#ff9800',
      'Culture & Society': '#ba68c8',
      Entertainment: '#ff5722',
      'Business & Industry': '#607d8b',
      Sports: '#e91e63',
      'Crime & Law': '#9c27b0',
      Lifestyle: '#009688',
      'Pets & Animals': '#ffa726',
      Education: '#3f51b5',
      'Technology & Society': '#8bc34a',
      'Meta & Media': '#795548',
      'Emotions & Tone': '#ce93d8',
      Events: '#ffb74d',
      'Geography & Regions': '#64b5f6',
      Miscellaneous: '#bdbdbd'
    };

    const icons = {
      'Politics & Government': 'landmark',
      'Economy & Finance': 'banknote',
      Technology: 'cpu',
      'Science & Environment': 'leaf',
      'Health & Wellness': 'heart-pulse',
      'Culture & Society': 'users',
      Entertainment: 'film',
      'Business & Industry': 'briefcase',
      Sports: 'trophy',
      'Crime & Law': 'gavel',
      Lifestyle: 'coffee',
      'Pets & Animals': 'paw-print',
      Education: 'book',
      'Technology & Society': 'shield',
      'Meta & Media': 'newspaper',
      'Emotions & Tone': 'message-circle',
      Events: 'calendar',
      'Geography & Regions': 'globe',
      Miscellaneous: 'circle'
    };

    const mapping = {};
    for (const [group, labels] of Object.entries(groups)) {
      const color = colors[group];
      const icon = icons[group];
      mapping[group.toLowerCase()] = { color, icon };
      labels.forEach((label) => {
        const key = label.toLowerCase();
        if (!mapping[key]) {
          mapping[key] = { color, icon };
        }
      });
    }
    return mapping;
  })()
};
